<template>
  <div class="app-main-page">
    <tab-warehouse ref="tabWarehouse" :context="context" :action="action" :cooperate-edit="cooperateEditWarehouse" />
    <tab-trucking v-if="job.landTransportation" ref="tabTrucking" :context="context" :action="action" :cooperate-edit="cooperateEditTrucking" />
  </div>
</template>

<script>
import tabWarehouse from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabWarehouse'
import tabTrucking from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabTrucking'
import { AirImportJob } from '@/class/model/booking/AirImportJob'

export default {
  name: 'AiTabLocalService',
  components: { tabWarehouse, tabTrucking },
  props: {
    context: { type: Object, required: true },
    action: { type: String, required: true },
    cooperateEditWarehouse: { type: Boolean, default: true }, // 能否修改: 仓储
    cooperateEditTrucking: { type: Boolean, default: true } // 能否修改:陆运
  },
  data() {
    return {
      job: new AirImportJob().fillDefaultValue().getData(),
      reloadTrucking: false
    }
  },
  watch: {
    'job.landTransportation': {
      handler(newVal) {
        if (!newVal) {
          this.reloadTrucking = true
        }
      }
    }
  },
  methods: {
    async onShow(row, isRefresh) {
      this.job = row
      row.aiRefresh = true
      this.$refs.tabWarehouse.onShow(row, isRefresh)
      if (row.landTransportation) {
        this.$nextTick(() => {
          this.$refs.tabTrucking.onShow(row, isRefresh || this.reloadTrucking)
          this.reloadTrucking = false
        })
      }
    },
    async getSubmitData() {
      const result = await this.$refs.tabWarehouse.getSubmitData()
      if (this.$refs.tabTrucking) {
        Object.assign(result, await this.$refs.tabTrucking.getSubmitData())
      }
      return result
    },
    getPrintData() {
      if (!this.checkPrint()) {
        return
      }
      const obj = this.job.landTransportation ? this.$refs.tabTrucking.truckingInfo : null
      const params = {}
      if (obj) {
        params.jobuuid = this.job.uuid
        params.WAREHOUSE_UUID = this.$refs.tabWarehouse.warehouseInfo.uuid || 'null'
        params.TRUCKING_UUID = obj.uuid || 'null'
        params.JOB_UUID = this.job.uuid
      } else {
        params.jobuuid = this.job.uuid
        params.WAREHOUSE_UUID = this.$refs.tabWarehouse.warehouseInfo.uuid || 'null'
        params.TRUCKING_UUID = 'null'
      }
      params.category = 'AIWT'
      params.ctx = new AirImportJob(this.job)
      return params
    },
    checkPrint() {
      if (this.job.landTransportation && this.action !== 'look') {
        const obj = this.$refs.tabTrucking.truckingInfo
        if (obj && !obj.uuid) {
          this.$message.info(this.$t('queryJob.DoorNotBeenSavedPrinted'))
          return false
        }
      }
      return true
    }
  }
}
</script>

<style>
</style>
